module.exports = __webpack_public_path__ + "img/emoji_59.a8d4270d.png";